import { useQueryWithUserId } from '@northladder/services';

import { TENANT_CONFIG_API } from '../tenantClient';

/**
 * This will be used to track the tenant config query.
 * @deprecated - @divyansh why do we have two query similar query keys, we need to merge them.
 */
export const TENANT_CONFIG_QUERY_KEY = 'tenant-config-query-key';

export interface ITenantConfigQueryOptions {
  /**
   * The `basePath`/`identifier` to be used for the API requests.
   * This will be used to resolve the required JSON object for the App.
   */
  identifier: string;
  /**
   * Whether the query is enabled or not.
   * This is used to conditionally fetch the data.
   */
  isEnabled?: boolean;
}

/**
 * This hook fetches the tenant config for the provided `identifier`.
 */
export const useTenantConfigQuery = ({
  identifier,
  isEnabled = true,
}: ITenantConfigQueryOptions) => {
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [TENANT_CONFIG_QUERY_KEY, identifier],
    queryFn: () => TENANT_CONFIG_API.fetchTenantConfig(identifier),
    retry: false,
    enabled: isEnabled && !!identifier,
    refetchOnWindowFocus: false,
  });

  return {
    error,
    isError,
    data,
    isPending,
    refetch,
  };
};
